import { Box } from '@mui/material';
import { useState } from 'react';
import { MDButton } from '../../../Component/Common/Components/MDButton';
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { OptionsSelectDropdown } from '../../../Component/Common/Components/OptionsSelectDropdown/OptionsSelectDropdown';
import { VAMethodologyPageList } from '../../../Component/Common/Constants/Lists/DropdownPageListOptions';
import { VaMethodologyPage } from './VAMethodologyPage';
import { VaMethodologyCreateModal } from './VaMethodologyModal/VaMethodologyCreateModal';
import { useRecoilValue } from 'recoil';
import { UserAtom } from '../../../State/user.Atom';



export const VAMethodologyHomePage = () => {
  const [selectedValue, setSelectedValue] = useState<number>(1);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const user = useRecoilValue(UserAtom);

  const handleDropdownChange = (newPageId: number) => {
    setSelectedValue(newPageId);
  };

  const handleOpenCreateModal = () => {
    setShowModal(true);
  };

  const getSelectedPage = (): { id: number, value: string } => {
    const selectedPage = VAMethodologyPageList.find((page) => page.id === selectedValue);
    return selectedPage ? { id: selectedPage.id, value: selectedPage.value } : { id: 0, value: '' };
  };

  const handleCloseCreateModal = () => {
    setShowModal(false);
    setRefreshKey(prevKey => prevKey + 1);
  }

  return (
    <>
      <Box>
        <MDTypography variant='h4' fontWeight='bold' sx={{ paddingBottom: "15px" }}>
          VA Methodology Management
        </MDTypography>
        <OptionsSelectDropdown items={VAMethodologyPageList} onChange={handleDropdownChange} />
        {(user.isAdmin) &&
        <MDButton sx={{ marginTop: "15px" }} color="primary" variant="contained" onClick={handleOpenCreateModal}>
          {`Create New ${getSelectedPage().value} Methodology`}
        </MDButton>
        }
        <VaMethodologyPage key={refreshKey} scorecardElementType={selectedValue} />
      </Box>

      {showModal &&
        <VaMethodologyCreateModal showModal={showModal} scorecardElement={getSelectedPage()} handleCloseModal={handleCloseCreateModal} selectedPage={getSelectedPage().value} />
      }
    </>
  )
}